import { ComponentPropsWithoutRef } from 'react'

import { useRouter } from 'next/router'

import { getBaseUrl } from '@/lib/contentful/utils'

import { Breadcrumbs } from '@/components/Breadcrumbs'
import { Warning } from '@/components/Warning'

import { useEntry } from '../Press.hooks'

export function PressReleasesBreadcrumbs(
	props: Omit<ComponentPropsWithoutRef<typeof Breadcrumbs>, 'breadcrumbs' | 'currentPage'>
) {
	const { locale } = useRouter()
	const entry = useEntry()

	if ('error' in entry) {
		return <Warning className={props.className}>{entry.error}</Warning>
	}

	const release = entry.data?.title

	if (!release) return null

	const localeToText = {
		'it-IT': 'Comunicati stampa',
		'es-ES': 'Notas de prensa',
		'de-DE': 'Pressemitteilungen',
		'fr-FR': 'Communiqués de presse',
		'nl-NL': 'Persberichten',
		'en-US': 'Press Releases'
	}

	const text = localeToText[locale as keyof typeof localeToText] || 'Press Releases'

	return (
		<Breadcrumbs
			{...props}
			dataTestid="press-release-breadcrumbs"
			breadcrumbs={[
				{
					text: text,
					link: { href: `${getBaseUrl(locale)}/press/releases/` },
					schemaUrl: `${getBaseUrl(locale)}/press/releases/`
				}
			]}
			currentPage={release}
		/>
	)
}
